import { isDev } from './constants'
import * as Sentry from './Sentry'

export function captureException(error: any, source?: string) {
  if (!isDev) {
    Sentry.captureException(error, source ? { tags: { source } } : {})
  } else {
    console.log(`Sentry captureException - ${source}`, error)
  }
}
